import { get } from 'lodash';
import { reject, resolve } from 'redux-optimist-promise';
import { FETCH_ADDITIONAL_ACCOMMODATIONS } from 'Store/booking/additional-accommodations/additionalAccommodations.action';
type State = boolean;
const initialState: State = false;

function isLoadingReducer(
  state: State = initialState,
  action: Action<any> | null | undefined,
): State {
  switch (get(action, 'type')) {
    case FETCH_ADDITIONAL_ACCOMMODATIONS:
      return true;

    case reject(FETCH_ADDITIONAL_ACCOMMODATIONS):
    case resolve(FETCH_ADDITIONAL_ACCOMMODATIONS):
      return false;

    default:
      return state;
  }
}

export default isLoadingReducer;
